// src/design-system/PageHeader.tsx
import type { ReactNode } from "react";

export function PageHeader({ title, path, actions }: { title: string; path?: string; actions?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-baseline gap-3">
      <h1 className="m-0 text-[26px] font-semibold tracking-[-0.2px]" style={{ textShadow: "0 0 26px rgba(214,172,85,.28)" }}>
        {title}
      </h1>
      {path && <span className="mono ltr text-xs text-muted-3">{path}</span>}
      {actions && <div className="ms-auto flex flex-wrap items-center gap-2.5">{actions}</div>}
    </div>
  );
}
